module.exports = {
	"version": "2.0",
	"metadata": {
		"apiVersion": "2015-02-01",
		"endpointPrefix": "elasticfilesystem",
		"protocol": "rest-json",
		"serviceAbbreviation": "EFS",
		"serviceFullName": "Amazon Elastic File System",
		"signatureVersion": "v4",
		"uid": "elasticfilesystem-2015-02-01"
	},
	"operations": {
		"CreateFileSystem": {
			"http": {
				"requestUri": "/2015-02-01/file-systems",
				"responseCode": 201
			},
			"input": {
				"type": "structure",
				"required": [
					"CreationToken"
				],
				"members": {
					"CreationToken": {},
					"PerformanceMode": {},
					"Encrypted": {
						"type": "boolean"
					},
					"KmsKeyId": {}
				}
			},
			"output": {
				"shape": "S6"
			}
		},
		"CreateMountTarget": {
			"http": {
				"requestUri": "/2015-02-01/mount-targets",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"FileSystemId",
					"SubnetId"
				],
				"members": {
					"FileSystemId": {},
					"SubnetId": {},
					"IpAddress": {},
					"SecurityGroups": {
						"shape": "Si"
					}
				}
			},
			"output": {
				"shape": "Sk"
			}
		},
		"CreateTags": {
			"http": {
				"requestUri": "/2015-02-01/create-tags/{FileSystemId}",
				"responseCode": 204
			},
			"input": {
				"type": "structure",
				"required": [
					"FileSystemId",
					"Tags"
				],
				"members": {
					"FileSystemId": {
						"location": "uri",
						"locationName": "FileSystemId"
					},
					"Tags": {
						"shape": "So"
					}
				}
			}
		},
		"DeleteFileSystem": {
			"http": {
				"method": "DELETE",
				"requestUri": "/2015-02-01/file-systems/{FileSystemId}",
				"responseCode": 204
			},
			"input": {
				"type": "structure",
				"required": [
					"FileSystemId"
				],
				"members": {
					"FileSystemId": {
						"location": "uri",
						"locationName": "FileSystemId"
					}
				}
			}
		},
		"DeleteMountTarget": {
			"http": {
				"method": "DELETE",
				"requestUri": "/2015-02-01/mount-targets/{MountTargetId}",
				"responseCode": 204
			},
			"input": {
				"type": "structure",
				"required": [
					"MountTargetId"
				],
				"members": {
					"MountTargetId": {
						"location": "uri",
						"locationName": "MountTargetId"
					}
				}
			}
		},
		"DeleteTags": {
			"http": {
				"requestUri": "/2015-02-01/delete-tags/{FileSystemId}",
				"responseCode": 204
			},
			"input": {
				"type": "structure",
				"required": [
					"FileSystemId",
					"TagKeys"
				],
				"members": {
					"FileSystemId": {
						"location": "uri",
						"locationName": "FileSystemId"
					},
					"TagKeys": {
						"type": "list",
						"member": {}
					}
				}
			}
		},
		"DescribeFileSystems": {
			"http": {
				"method": "GET",
				"requestUri": "/2015-02-01/file-systems",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"members": {
					"MaxItems": {
						"location": "querystring",
						"locationName": "MaxItems",
						"type": "integer"
					},
					"Marker": {
						"location": "querystring",
						"locationName": "Marker"
					},
					"CreationToken": {
						"location": "querystring",
						"locationName": "CreationToken"
					},
					"FileSystemId": {
						"location": "querystring",
						"locationName": "FileSystemId"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Marker": {},
					"FileSystems": {
						"type": "list",
						"member": {
							"shape": "S6"
						}
					},
					"NextMarker": {}
				}
			}
		},
		"DescribeMountTargetSecurityGroups": {
			"http": {
				"method": "GET",
				"requestUri": "/2015-02-01/mount-targets/{MountTargetId}/security-groups",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"MountTargetId"
				],
				"members": {
					"MountTargetId": {
						"location": "uri",
						"locationName": "MountTargetId"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"SecurityGroups"
				],
				"members": {
					"SecurityGroups": {
						"shape": "Si"
					}
				}
			}
		},
		"DescribeMountTargets": {
			"http": {
				"method": "GET",
				"requestUri": "/2015-02-01/mount-targets",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"members": {
					"MaxItems": {
						"location": "querystring",
						"locationName": "MaxItems",
						"type": "integer"
					},
					"Marker": {
						"location": "querystring",
						"locationName": "Marker"
					},
					"FileSystemId": {
						"location": "querystring",
						"locationName": "FileSystemId"
					},
					"MountTargetId": {
						"location": "querystring",
						"locationName": "MountTargetId"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Marker": {},
					"MountTargets": {
						"type": "list",
						"member": {
							"shape": "Sk"
						}
					},
					"NextMarker": {}
				}
			}
		},
		"DescribeTags": {
			"http": {
				"method": "GET",
				"requestUri": "/2015-02-01/tags/{FileSystemId}/",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"FileSystemId"
				],
				"members": {
					"MaxItems": {
						"location": "querystring",
						"locationName": "MaxItems",
						"type": "integer"
					},
					"Marker": {
						"location": "querystring",
						"locationName": "Marker"
					},
					"FileSystemId": {
						"location": "uri",
						"locationName": "FileSystemId"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"Tags"
				],
				"members": {
					"Marker": {},
					"Tags": {
						"shape": "So"
					},
					"NextMarker": {}
				}
			}
		},
		"ModifyMountTargetSecurityGroups": {
			"http": {
				"method": "PUT",
				"requestUri": "/2015-02-01/mount-targets/{MountTargetId}/security-groups",
				"responseCode": 204
			},
			"input": {
				"type": "structure",
				"required": [
					"MountTargetId"
				],
				"members": {
					"MountTargetId": {
						"location": "uri",
						"locationName": "MountTargetId"
					},
					"SecurityGroups": {
						"shape": "Si"
					}
				}
			}
		}
	},
	"shapes": {
		"S6": {
			"type": "structure",
			"required": [
				"OwnerId",
				"CreationToken",
				"FileSystemId",
				"CreationTime",
				"LifeCycleState",
				"NumberOfMountTargets",
				"SizeInBytes",
				"PerformanceMode"
			],
			"members": {
				"OwnerId": {},
				"CreationToken": {},
				"FileSystemId": {},
				"CreationTime": {
					"type": "timestamp"
				},
				"LifeCycleState": {},
				"Name": {},
				"NumberOfMountTargets": {
					"type": "integer"
				},
				"SizeInBytes": {
					"type": "structure",
					"required": [
						"Value"
					],
					"members": {
						"Value": {
							"type": "long"
						},
						"Timestamp": {
							"type": "timestamp"
						}
					}
				},
				"PerformanceMode": {},
				"Encrypted": {
					"type": "boolean"
				},
				"KmsKeyId": {}
			}
		},
		"Si": {
			"type": "list",
			"member": {}
		},
		"Sk": {
			"type": "structure",
			"required": [
				"MountTargetId",
				"FileSystemId",
				"SubnetId",
				"LifeCycleState"
			],
			"members": {
				"OwnerId": {},
				"MountTargetId": {},
				"FileSystemId": {},
				"SubnetId": {},
				"LifeCycleState": {},
				"IpAddress": {},
				"NetworkInterfaceId": {}
			}
		},
		"So": {
			"type": "list",
			"member": {
				"type": "structure",
				"required": [
					"Key",
					"Value"
				],
				"members": {
					"Key": {},
					"Value": {}
				}
			}
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/elasticfilesystem-2015-02-01.min.json
// module id = 609
// module chunks = 0